var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-box"},[_vm._m(0),_c('div',{staticClass:"echarts"},[_c('div',{style:({
        width: '2240px',
        height: '200px',
        margin: '0 auto',
      }),attrs:{"id":"dayly"}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-title d-aligncnter"},[_c('img',{staticClass:"img-24",staticStyle:{"margin-right":"4px","width":"24px","height":"24px"},attrs:{"src":require("@/assets/img/cockpit/calendar.svg")}}),_vm._v("近2周参测人数统计 ")])
}]

export { render, staticRenderFns }